import React from 'react';
import './Preloader.css';

const Preloader = () => {
  return (
    <>
      <div className="preloader-backdrop" />
      <div className="preloader-card">
        <div className="preloader-fish-scene" aria-hidden="true">
          <svg
            className="preloader-fish-svg"
            viewBox="0 0 120 58"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient
                id="preloaderFishBodyGrad"
                x1="0%"
                y1="0%"
                x2="0%"
                y2="100%"
              >
                <stop offset="0%" stopColor="#3dd4c9" />
                <stop offset="55%" stopColor="#00b8ae" />
                <stop offset="100%" stopColor="#009b94" />
              </linearGradient>
              <linearGradient
                id="preloaderFishTailGrad"
                x1="100%"
                y1="0%"
                x2="0%"
                y2="0%"
              >
                <stop offset="0%" stopColor="#00acac" />
                <stop offset="100%" stopColor="#007f7c" />
              </linearGradient>
            </defs>

            <g className="preloader-fish-whole">
              {/* Tail — triangle, wag */}
              <g transform="translate(34, 29)">
                <g className="preloader-fish-tail-wag">
                  <path
                    d="M 0 0 L -24 -13 L -24 13 Z"
                    fill="url(#preloaderFishTailGrad)"
                  />
                </g>
              </g>

              {/* Body + face + fins (subtle “breathing” scale) */}
              <g className="preloader-fish-body-breathe">
                <ellipse
                  cx="60"
                  cy="29"
                  rx="33"
                  ry="15.5"
                  fill="url(#preloaderFishBodyGrad)"
                />
                {/* Soft belly strip — flat highlight */}
                <ellipse
                  cx="63"
                  cy="31"
                  rx="20"
                  ry="7"
                  fill="rgba(255,255,255,0.22)"
                />
                {/* Dorsal fin — filled semicircle cap */}
                <path
                  className="preloader-fish-dorsal"
                  d="M 49 17 Q 60 5 71 17 L 70.5 18.5 Q 60 8.5 49.5 18.5 Z"
                  fill="#00a39e"
                />
                {/* Pectoral — lighter curved stroke */}
                <path
                  className="preloader-fish-pectoral"
                  d="M 52 32 Q 46 38 50 44"
                  fill="none"
                  stroke="rgba(255,255,255,0.45)"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
                {/* Eye */}
                <circle cx="77" cy="25" r="4.5" fill="#fff" />
                <circle cx="78.2" cy="24" r="2.2" fill="#1c3333" />
                <circle cx="79" cy="23.3" r="0.9" fill="#fff" opacity="0.9" />
                {/* Snout + barbule */}
                <path
                  d="M 88 28 L 93 28"
                  stroke="#006b68"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                />
                <path
                  className="preloader-fish-barbule"
                  d="M 93 29 Q 95 34 92 38"
                  fill="none"
                  stroke="#005c59"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
              </g>

              {/* Bubbles — in front of mouth */}
              <circle className="preloader-bubble preloader-bubble-1" cx="100" cy="42" r="2.8" strokeWidth="0.4" />
              <circle className="preloader-bubble preloader-bubble-2" cx="106" cy="30" r="2.2" strokeWidth="0.4" />
              <circle className="preloader-bubble preloader-bubble-3" cx="98" cy="20" r="1.6" strokeWidth="0.4" />
            </g>
          </svg>
        </div>
      </div>
    </>
  );
};

export default Preloader;
